import {inject, Injectable, resource} from '@angular/core';
import {Observable} from 'rxjs';
import {take} from 'rxjs/operators';
import {SecteurActiviteDTO} from '../../dtos/secteur-activite-dto';
import {HttpService} from '../technique/http.service';
import {GraphQLService} from '../technique/graphql.service';
import {Auth2Service} from '../security/auth2.service';
import {ResponseWrapper} from '../../suppliers/wrappers/response-wrapper';
import {IsDeletableObject} from '../../models/is-deletable-object';

@Injectable({
  providedIn: 'root'
})
export class SecteurActiviteService {

  private readonly httpSvc = inject(HttpService);
  private readonly graphQlSvc = inject(GraphQLService);
  private readonly auth2Svc = inject(Auth2Service);

  readonly secteursActiviteResource = resource<SecteurActiviteDTO[], void>({
    loader: async () => {
      const siteIds = this.auth2Svc.utilisateur.sites.map(s => s.id);
      const response: any = await this.graphQlSvc.sendQuery(`
        {
          allSecteursActivite(filters: {
            siteIds: [${siteIds}]
          }) {
            id,
            code,
            libelle,
            actif,
            site {
              id,
              libelle,
            },
          }
        }
      `).pipe(take(1)).toPromise();
      return (response?.allSecteursActivite ?? []) as SecteurActiviteDTO[];
    }
  });

  delete = (ids: number[]): Observable<ResponseWrapper<IsDeletableObject>> =>
    this.httpSvc.delete(`dolrest/referentiel/secteur-activite/delete?ids=${ids.join(',')}`);

  save = (dto: SecteurActiviteDTO): Observable<ResponseWrapper<SecteurActiviteDTO>> =>
    this.httpSvc.post('dolrest/referentiel/secteur-activite/save', dto);

  canModify = (dto: SecteurActiviteDTO): boolean => {
    if (!dto?.site?.id || dto.site.id === 0) { return true; }
    return this.auth2Svc.isSiteLocal(dto.site.id);
  };
}
